import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _map from "lodash/map";
var _excluded = ["spacing", "children", "className", "style", "component"];
import React from 'react';
import PropTypes from 'prop-types';
import baseStyles, { mergeStyles } from '@nerdwallet/base-styles/react';
import { propTypes, defaultProps } from './api';
var ContainerImpl = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var spacing = _ref.spacing,
      children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      component = _ref.component,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(component, _objectSpread(_objectSpread(_objectSpread({}, mergeStyles(baseStyles(_map(spacing, function (val, key) {
    return "margin-".concat(key, "-").concat(val);
  })), {
    className: className,
    style: style
  })), otherProps), {}, {
    ref: ref
  }), children);
});
ContainerImpl.displayName = 'ContainerImpl';
ContainerImpl.propTypes = _objectSpread(_objectSpread({}, propTypes), {}, {
  component: PropTypes.elementType
});
ContainerImpl.defaultProps = defaultProps;
export default ContainerImpl;